export default {
  "content": "<path d=\"M1.2 9h11.18L7.5 13.88a1 1 0 000 1.42 1 1 0 001.4 0l6.6-6.59a1 1 0 000-1.41L8.92.7A1 1 0 107.5 2.11L12.38 7H1.2a1 1 0 00-1 1 1 1 0 001 1z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "#333",
    "viewBox": "0 0 16 16"
  }
};